var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('eventsList'),(!_vm.$store.state.privateEvent.unsaved.events.length)?_c('eventsAdd'):_vm._e(),(_vm.checkData())?_c('saveBtn',{staticClass:"saveBtn",attrs:{"callback":function() {
        _vm.setSave();
      }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }